import { baseApi } from './base.service';
import { PATH } from './__fixtures__/service-fixtures';
import { type Role } from '../models/role';

export type RolesResponse = {
  roles: Role[];
};

export const allRoles = {
  name: 'All Roles',
  id: '',
};

const rolesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getRoles: build.query<RolesResponse, {}>({
      query: () => PATH.roles,
    }),
  }),
});

export const { useGetRolesQuery } = rolesApi;

export default rolesApi;
